var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAntenna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 0.925C7.02083 0.925 7.70833 1.2 8.25833 1.70417L8.625 1.3375C7.98333 0.695833 7.15833 0.375 6.33333 0.375C5.50833 0.375 4.68333 0.695833 4.04167 1.3375L4.40833 1.70417C4.95833 1.2 5.64583 0.925 6.33333 0.925ZM4.82083 2.07083L5.1875 2.4375C5.50833 2.11667 5.92083 1.97917 6.33333 1.97917C6.74583 1.97917 7.15833 2.11667 7.47917 2.4375L7.84583 2.07083C7.43333 1.65833 6.88333 1.42917 6.33333 1.42917C5.78333 1.42917 5.23333 1.65833 4.82083 2.07083ZM7.70833 4.95833H6.79167V3.125H5.875V4.95833H1.29167C0.7875 4.95833 0.375 5.37083 0.375 5.875V7.70833C0.375 8.2125 0.7875 8.625 1.29167 8.625H7.70833C8.2125 8.625 8.625 8.2125 8.625 7.70833V5.875C8.625 5.37083 8.2125 4.95833 7.70833 4.95833ZM7.70833 7.70833H1.29167V5.875H7.70833V7.70833ZM1.75 6.33333H2.66667V7.25H1.75V6.33333ZM3.35417 6.33333H4.27083V7.25H3.35417V6.33333ZM4.95833 6.33333H5.875V7.25H4.95833V6.33333Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAntenna);
export default __webpack_public_path__ + "static/media/icon_antenna.739ebb5469de6ba7da9912fa450251d5.svg";
export { ForwardRef as ReactComponent };